<template>
  <div>
    <el-form-item :label="$t('i18n.b985c54ec0b64c37852c22562475f1ce')" prop="name">
      <el-input
        v-model="form.name"
        maxlength="50"
        show-word-limit
        :placeholder="$t('i18n.a6d61a9d34474ef5bcbb83938e05c756')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('i18n.78209f56e1884816bad4aac43c7a1a7b') + '1'" prop="region">
      <el-input v-model="form.countryTips" maxlength="100" show-word-limit :placeholder="form.countryTips"></el-input>
    </el-form-item>

    <el-form-item :label="$t('i18n.0a5d225866204083972f74127963080b')" prop="region">
      <el-checkbox v-model="form.countryRequire">{{ $t('i18n.ca2f54a11aaf46d49f46588e55bbab1a') }}</el-checkbox>
    </el-form-item>

    <el-form-item :label="$t('i18n.78209f56e1884816bad4aac43c7a1a7b') + '2'" prop="region">
      <el-input v-model="form.detailTips" maxlength="100" show-word-limit :placeholder="form.detailTips"></el-input>
    </el-form-item>

    <el-form-item :label="$t('i18n.0a5d225866204083972f74127963080b') + '2'" prop="region">
      <el-checkbox v-model="form.detailRequire">{{ $t('i18n.ca2f54a11aaf46d49f46588e55bbab1a') }}</el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
